import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { dateFormatPipe } from '@app/pipes/datepipe';
import { DateFormat } from '@models/date-format';
import { RequestMerchantStateService } from '@services/state-management/request-merchant-state.service';
import { Moment } from 'moment';
import { combineLatest, map, shareReplay } from 'rxjs';

@Component({
    selector: 'medpace-merchant-details-view',
    imports: [dateFormatPipe, UpperCasePipe, AsyncPipe],
    templateUrl: './merchant-details-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MerchantDetailsViewComponent {
    DateFormat = DateFormat;
    model = input.required<{
        transactionDate: Moment | null;
        merchant: number | null;
    }>();
    model$ = toObservable(this.model);
    private requestMerchantStateService = inject(RequestMerchantStateService);

    travelMerchantValues$ = this.requestMerchantStateService.getTravelRequestMerchants();
    merchantValue$ = combineLatest({
        model: this.model$,
        merchantValues: this.travelMerchantValues$,
    }).pipe(
        map(({ merchantValues, model }) => {
            return merchantValues.find((x) => x.value === model.merchant);
        }),
        shareReplay(1)
    );
}
